import React, { FC, MutableRefObject, ReactElement, useContext, useRef, useState } from 'react'
import { Popper } from '@material-ui/core'
import IconButton, { IconButtonType } from '../../Common/Components/IconButton'
import { IconName } from '../../Common/Components/Icon'
import { LanguageContext, PromptContext, ReactState } from '../../Common/Contexts'
import { PromptDisplayType } from '../../Common/Contexts/PromptContext'
import { ManageQueues as ManageQueuesLanguage } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { IconSize } from '../../../NonReact/constants/React/Icon/Constants'

type Props = {
    onClick: () => void
    guardMessage: string | ReactElement
    popperMessage: string
    disabled: boolean
    icon: IconName
}

export const MonitoringButton: FC<Props> = ({
    onClick,
    disabled,
    guardMessage,
    popperMessage,
    icon
}: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    const buttonRef: MutableRefObject<null> = useRef<null>(null)
    const [isDisabledPopperShown, setIsDisabledPopperShown]: ReactState<boolean> = useState<boolean>(false)

    const { displayPromptPromise }: PromptDisplayType = useContext(PromptContext)

    return (
        <div>
            <IconButton
                onMouseOver={(): void => setIsDisabledPopperShown(true)}
                onMouseOut={(): void => setIsDisabledPopperShown(false)}
                onClick={(): void => {
                    displayPromptPromise(
                        guardMessage,
                        language.get(ManageQueuesLanguage.ManageQueue_DisableEnableRealtime_Confirm),
                        language.get(ManageQueuesLanguage.ManageQueue_DisableEnableRealtime_Cancel)
                    ).then((): void => onClick())
                }}
                type={IconButtonType.BUTTON}
                iconName={icon}
                iconSize={IconSize.LARGE}
                isEnabled={disabled}
                ref={buttonRef}
            />

            <Popper
                anchorEl={buttonRef.current}
                open={isDisabledPopperShown}
                className='ubeu-remove-confirm-popper'
                placement='top'
            >
                <div className='ubeu-remove-confirm-message'>{popperMessage}</div>
            </Popper>
        </div>
    )
}
